



























































import Vue from 'vue';

// Services
import UserConsentContext, { CONSENT_OPTIONS } from '~/services/UserConsentContext';
import UserInfoService from '~/services/UserInfoService';
import VFairService, { VFair, VFairPavilion, VFairUser } from '~/services/VFairService';
import SchoolService from '~/services/SchoolService';

// Components
import CKEditorContent from '~/components/builders/CKEditorContent.vue';
import Paper from '~/components/builders/Paper.vue';
import Pavilions from '../components/Pavilions.vue';
import MainLayout from '~/components/layouts/mainlayout/MainLayout.vue';
import RegisterProfileModal from '../components/RegisterProfileModal.vue';
import VFairHeader, { HeaderButtonType } from '../components/VFairHeader.vue';

// Utils
import addDays from 'date-fns/addDays';
import isAfter from 'date-fns/isAfter';
import isWithinInterval from 'date-fns/isWithinInterval';
import URLS from '~/URLS';

// Assets
import MasterClassImage from '../../../assets/img/vcf/masterclassSucceed.png';
import isBefore from 'date-fns/isBefore';

export default Vue.extend({
    name: 'VFairDetails',
    components: {
        MainLayout,
        VFairHeader,
        Pavilions,
        CKEditorContent,
        Paper,
        RegisterProfileModal,
    },
    data() {
        return {
            isLoadingUser: false,
            masterClassImage: MasterClassImage,
            hasAdminAccess: false,
            showProfileModal: false,

            profileValid: false,
            isRegistering: false,
            registrationCompleted: false,

            pavilionId: null as string | null,
            pavilions: [] as VFairPavilion[],
            pavilionsLoading: false,

            activityUpdater: null as number | null,
        };
    },
    computed: {
        interfaces(): any {
            return (this as any).$interfaces;
        },
        vfair(): any {
            if (this.$route.params.id) {
                return this.interfaces.vfair.id(this.$route.params.id).get({
                    reactive: true,
                });
            } else {
                return { loading: true };
            }
        },
        vFairUser: {
            get(): VFairUser | undefined {
                return (this as any).$interfaces.vfairModule.getVFairUser();
            },
            set(newValue: VFairUser) {
                (this as any).$interfaces.vfairModule.setVFairUser(newValue);
            },
        },

        hasAccess(): boolean {
            if (!this.isAuthenticated || !this.data) return false;

            if (this.data.personalInvites) {
                if (this.hasAdminAccess) return true;
                if (!this.vFairUser) return false;
                return this.vFairUser.invited;
            }

            return true;
        },
        isAuthenticated(): boolean {
            return this.interfaces.logInModule.isLoggedIn();
        },
        isOngoing(): boolean {
            const { start, end } = this.data;
            if (typeof start === 'undefined') return false;
            if (!end || isNaN(start.getTime()) || isNaN(end.getTime())) return true;
            if (isBefore(end, start)) return false;

            return isWithinInterval(new Date(), { start, end });
        },
        isInvited(): boolean {
            if (this.hasAdminAccess) return true;
            if (!this.vFairUser) return false;
            return this.vFairUser.invited;
        },
        isInterested(): boolean {
            if (this.vFairUser) return this.vFairUser.interested;
            else return false;
        },
        hackEnabled(): boolean {
            return this.interfaces.vfairModule.getHackEnabled();
        },

        data(): Partial<VFair> {
            if (Array.isArray(this.vfair.data)) return {};
            return {
                ...this.vfair.data,
                start: new Date(this.vfair.data.start),
                end: new Date(this.vfair.data.end),
            };
        },

        showPavilions(): boolean {
            return (
                !!this.pavilions.length &&
                !!this.$route.params.id &&
                this.hasAccess &&
                this.isInterested &&
                (this.isOngoing || this.hackEnabled)
            );
        },
        registerButtonType(): HeaderButtonType {
            // No button: If loading, no data or user not invited (with personal invite type event)
            if (
                this.loading() ||
                !this.data ||
                (this.data.personalInvites && this.vFairUser && this.vFairUser.invited == false)
            )
                return null;

            const now = new Date();
            const { start, end } = this.data;

            // Enter-button: If start/end is not valid date
            if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) return 'enter';
            // Enter-button: If user is registered, and event has begun
            if (this.isInterested && isWithinInterval(now, { start, end })) return 'enter';
            // No button: If event is over
            if (isAfter(now, end)) return null;

            // Register-button: If event has not begun, or user is not registered
            return this.isInterested ? 'calendar' : 'register';
        },
        hideRegisterButton(): boolean {
            return this.showPavilions && this.registerButtonType === 'enter';
        },
    },
    methods: {
        checkAdminAccess(): void {
            const vFairId = this.$route.params.id;
            if (UserInfoService.isHigheredAdmin()) {
                this.hasAdminAccess = true;
                return;
            }

            const adminIds = UserInfoService.getOrgAdminIds();
            if (adminIds.length > 0) {
                VFairService.isAnyOrganizationActiveOnVfair(vFairId, adminIds).then(active => {
                    if (active) {
                        this.hasAdminAccess = true;
                    }
                });
                VFairService.isAnySchoolActiveOnVfair(vFairId, adminIds).then(active => {
                    if (active) {
                        this.hasAdminAccess = true;
                    }
                });
            } else {
                this.hasAdminAccess = false;
            }
        },
        loading(): boolean {
            return !!this.vfair.loading;
        },

        goToVFair() {
            if (!this.vfair.data || !this.vfair.data.id) return;

            const pavilion = !!this.pavilionId ? `?pavilion_id=${this.pavilionId}` : '';
            this.pavilionId = null;

            this.$router.push(`${URLS.vfair}/${this.vfair.data.id}${pavilion}`);
        },

        handleInterestedClick() {
            if (!this.isAuthenticated) {
                this.interfaces.logInModule.requireLogIn(this.$route.path);
                return;
            }
            if (this.profileValid && this.registerButtonType === 'register') {
                this.handleRegister(true);
                return;
            }
            if (this.profileValid && this.registerButtonType === 'enter') {
                this.goToVFair();
                return;
            }

            this.showProfileModal = true;
        },
        handleRegister(showCompleted = false) {
            if (this.registerButtonType === 'enter') {
                this.isLoadingUser = false;
                this.isRegistering = false;
                this.registrationCompleted = true;
                this.showProfileModal = false;

                this.goToVFair();
                return;
            }

            this.isLoadingUser = true;
            this.isRegistering = true;

            this.interfaces.vfairuser.user.me
                .vfair_id(this.$route.params.id)
                .post({ body: { interested: true } })
                .then(() => {
                    this.interfaces.vfairuser.user.me
                        .vfair_id(this.$route.params.id)
                        .get({ forceUpdate: true })
                        .then((user: any) => {
                            this.vFairUser = user.data;
                            this.isLoadingUser = false;
                            this.isRegistering = false;
                            this.registrationCompleted = true;

                            if (showCompleted) this.showProfileModal = true;
                        });
                });
        },
        handleOpenPavilion(pavilionId: string) {
            if (!this.data.id) return;
            this.pavilionId = pavilionId;
            this.handleInterestedClick();
        },

        fetchPavilions() {
            if (!this.$route.params.id) return;

            this.pavilionsLoading = true;
            VFairService.getPavilions(this.$route.params.id)
                .then(res => (this.pavilions = res.data))
                .finally(() => (this.pavilionsLoading = false));
        },
        fetchVFairUserData() {
            this.isLoadingUser = true;
            this.interfaces.vfairuser.user.me
                .vfair_id(this.$route.params.id)
                .get({
                    forceUpdate: true,
                })
                .then((data: any) => {
                    if (data && data.data && data.data.id) {
                        this.vFairUser = data.data;
                    }
                })
                .catch(console.error)
                .finally(() => (this.isLoadingUser = false));
        },
        async initWebinarMessages() {
            const vFairId = this.$route.params.id;
            if (!vFairId) return;

            const from = new Date();
            const to = addDays(from, 1);

            const result = await VFairService.getWebinars(vFairId, {
                shallow: true,
                from,
                to,
            });
            if (!result || result.status !== 200) return;

            const { data: webinars } = result;
            if (!webinars.length) return;

            const withVFairId = webinars.map(wb => ({ ...wb, vFairId }));

            const service = this.interfaces.webinarMessageModule.getService();
            if (!service) return;
            service.addWebinars(withVFairId);
        },
        updateUserActivity() {
            if (this.hasAccess && this.isOngoing) {
                const vFairId = this.$route.params.id;
                return VFairService.updateUserActivity(vFairId);
            }
        },
    },
    mounted() {
        const schoolId = SchoolService.getCurrentSchoolId();
        const schoolName = SchoolService.getCurrentSchoolName();
        this.interfaces.communication.chat.user.me.get({
            analytics_consent: UserConsentContext.getOption(CONSENT_OPTIONS.ANALYTICS),
            school_id: schoolId,
            school_name: schoolName,
        });

        this.checkAdminAccess();
        this.interfaces.vfairModule.setPavilionId(null);
        if (this.isAuthenticated) this.fetchVFairUserData();

        this.fetchPavilions();
        this.initWebinarMessages();

        this.activityUpdater = setInterval(this.updateUserActivity, 5000);
    },
    beforeDestroy() {
        if (this.activityUpdater) clearInterval(this.activityUpdater);
    },
});
